import {getPrivateAxios} from '@blesk-frontend/api';

export interface AuthTeamData {
  teamId: string;
}

export interface AuthTeamResponse {
  accessToken: string;
}

/**
 *
 * @param data
 */
export const fetchAuthTeam = async (data: AuthTeamData) => {
  const response = await getPrivateAxios().post<AuthTeamResponse>('/auth/team', data);
  return response.data;
};
